<template>
  <div class="seezhengshu">
    <div style="margin-top: 30px">
      <el-table :data="tableData" border style="width: 90%; margin: 0 auto">
        <!-- <el-table-column type="selection" align='center'>
					</el-table-column> -->
        <el-table-column
          prop="organization_name"
          label="机构名称"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" align="center">
        </el-table-column>

        <el-table-column label="操作" align="center" width="300">
          <template slot-scope="scope">
            <el-row>
              <el-col>
                <!-- scope.row -->
                <!-- {{scope.row}} -->
                <el-button
                  plain
                  type="success"
                  size="mini"
                  @click="see(scope.row)"
                  >查看</el-button
                >
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="查看证书"
        :visible.sync="seeorderdialogVisible"
        width="50%"
      >
        <img style="width: 100%" :src="seeImgUrl" alt="" />
        <span slot="footer" class="dialog-footer">
          <el-button style="float: left" type="primary" @click="downLoad"
            >下载</el-button
          >
          <el-button @click="seeorderdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="seeorderdialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { trainorder_certlist } from "../assets/js/network/network.js";
import UtilityTime from "@/assets/js/utility/UtilityTime";
export default {
  components: {},
  data() {
    return {
      downloadimgname: "",
      seeorderdialogVisible: false,
      tableData: [],
      seeImgUrl: "",
    };
  },
  mounted() {
    this.getList(); //获取证书列表
  },
  methods: {
    getList() {
      let data = {};
      trainorder_certlist(data).then((res) => {
        if (res.code == 0) {
          //   console.log(res);
          this.tableData = res.ret;
          this.tableData.map((item) => {
            item.create_time = UtilityTime.retun_formatDate11(item.create_time);
          });
        }
      });
    },
    // 查看
    see(v) {
      // console.log(v)
      this.seeImgUrl = v.cert_fileurl;
      this.downloadimgname = v.organization_name;
      this.seeorderdialogVisible = true;
    },
    //下载
    downLoad() {
      this.downVideo(this.seeImgUrl, this.downloadimgname + "-授权证书");
    },
    downVideo(url, name) {
      // console.log(url,name)
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "arraybuffer"; // 返回类型blob
      xhr.onload = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          let blob = this.response;
          // 转换一个blob链接
          let u = window.URL.createObjectURL(
            new Blob([blob], {
              type: "image/png",
            })
          );
          let a = document.createElement("a");
          a.download = name;
          a.href = u;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
      };
      xhr.send();
    },
  },
};
</script>
<style scoped>
@import "../style/common.css";
</style>
